import { configureStore } from '@reduxjs/toolkit';
import messageSlice from '../redux/messageSlice'
import taskSlice from '../redux/taskSlice'
import dashboardSlice from '../redux/dashboardSlice'

export const store = configureStore({
    reducer: {
        message: messageSlice,
        task: taskSlice,
        dashboard: dashboardSlice,
    },
});
